import { render, staticRenderFns } from "./ManageUserAccessTokensPage.vue?vue&type=template&id=e567c030&scoped=true"
import script from "./ManageUserAccessTokensPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManageUserAccessTokensPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ManageUserAccessTokensPage.vue?vue&type=style&index=0&id=e567c030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e567c030",
  null
  
)

export default component.exports